<mat-card class="dialog-card">
  <mat-card-title class="dialog-card-header">
    <mat-toolbar class="dialog-toolbar" color="accent" fxLayout="row" fxLayoutAlign="space-between center">
      <h1 class="dialog-card-title">{{ (data?.user ? 'I18N_ADMIN.DIALOG.USER_FORM.EDIT_TITLE' : 'I18N_ADMIN.DIALOG.USER_FORM.CREATE_TITLE') | translate }}</h1>
      <button (click)="close()" class="regular-round-button" mat-icon-button>
        <mat-icon>close</mat-icon>
      </button>
    </mat-toolbar>
  </mat-card-title>
  <mat-card-content class="dialog-card-content p-4" fxLayout="column">
    <form [formGroup]="usersForm" fxFlex fxLayout="column" fxLayoutGap="10px">
      <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <mat-form-field color="accent" fxFlex>
          <mat-label>{{ 'I18N_ADMIN.DIALOG.USER_FORM.FIRST_NAME_PLACEHOLDER' | translate }}</mat-label>
          <input formControlName="firstname" matInput maxlength="50" required />
        </mat-form-field>
        <mat-form-field color="accent" fxFlex>
          <mat-label>{{ 'I18N_ADMIN.DIALOG.USER_FORM.LAST_NAME_PLACEHOLDER' | translate }}</mat-label>
          <input formControlName="lastname" matInput maxlength="50" required />
        </mat-form-field>
        <mat-form-field color="accent" fxFlex>
          <mat-label>{{ 'I18N_ADMIN.DIALOG.USER_FORM.EMAIL_PLACEHOLDER' | translate }}</mat-label>
          <input (input)="emailControl.setValue($event.target.value.toLowerCase().trim())" formControlName="email" matInput maxlength="50" required />
          @if (emailControl.invalid) {
            <mat-error
              >{{ (emailControl.errors.used ? 'I18N_ADMIN.DIALOG.COMMON.ERROR_MESSAGE.DUPLICATE_EMAIL' : 'FORM.ERROR_MESSAGE.INVALID_EMAIL') | translate }}
            </mat-error>
          }
        </mat-form-field>
      </div>
      <div fxFlex fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px">
        <mat-form-field class="" color="accent" fxFlex>
          <mat-label>{{ 'USERS.PROFILE_PREFERENCES.LANGUAGE' | translate }}</mat-label>
          <mat-select formControlName="language">
            @for (language of availableLanguages; track language) {
              <mat-option [value]="language">
                {{ 'USERS.PROFILE_PREFERENCES.LANGUAGES.' + language | translate }}
              </mat-option>
            }
          </mat-select>
        </mat-form-field>
        <mat-form-field color="accent" fxFlex>
          <mat-label>{{ 'IOT_DICTIONARY.COUNTRY' | translate }}</mat-label>
          <mat-select formControlName="country" required>
            @for (country of countries$ | async; track country.key) {
              <mat-option [value]="country.key">{{ country.value }}</mat-option>
            }
          </mat-select>
        </mat-form-field>
      </div>
    </form>
  </mat-card-content>
  <mat-card-actions class="dialog-card-actions" fxLayout="row" fxLayoutAlign="end center">
    <button (click)="close()" class="button-regular" mat-button>{{ 'I18N_ADMIN.DIALOG.USER_FORM.CANCEL' | translate | uppercase }}</button>
    <button (click)="save()" [disabled]="isUserFormDisabled()" class="button-regular" color="accent" mat-raised-button>
      {{ 'I18N_ADMIN.DIALOG.USER_FORM.SAVE' | translate | uppercase }}
    </button>
  </mat-card-actions>
</mat-card>
